// extracted by mini-css-extract-plugin
module.exports = {"inputChinese":"style_inputChinese__2CbJo"};